import React, { useState } from 'react';
import { Input, ModalBody, ModalHeader } from 'reactstrap';
import Rodal from '../../../../../components/Rodal/Rodal';
import { LoiFormSection } from '../../../../../slices/marketplace/loi-form/loi-form-section';
import {
    TermsFormLinkedField,
    TermsFormLinkedFieldOptions,
} from '../../../../../slices/marketplace/loi-form/terms-form-linked-field';
import { generateGuid } from '../../../../../utils/typedHelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import './LoiFormSectionEditorModal.scss';

export interface LoiFormSectionEditorModalProps {
    isVisible: boolean;
    onClose: () => void;
    sections: LoiFormSection[];
    onSectionsChange: (sections: LoiFormSection[]) => void;
}

export const LoiFormSectionEditorModal = (
    props: LoiFormSectionEditorModalProps
) => {
    const [sections, setSections] = useState<LoiFormSection[]>(props.sections);
    const [newSectionName, setNewSectionName] = useState('');

    const sectionsOrdered = [...sections].sort((a, b) => a.order - b.order);

    const handleAdd = () => {
        if (!newSectionName.trim()) return;
        const order =
            sections.length === 0
                ? 0
                : Math.max(...sections.map((s) => s.order)) + 1;
        setSections([
            ...sections,
            { id: generateGuid(), name: newSectionName.trim(), order, termsFormLinkedField: null },
        ]);
        setNewSectionName('');
    };

    const handleTermsFormLinkedFieldChange = (id: string, termsFormLinkedField: TermsFormLinkedField | null) => {
        setSections((prev) =>
            prev.map((s) => (s.id === id ? { ...s, termsFormLinkedField } : s))
        );
    };

    const handleDelete = (id: string) => {
        setSections(sections.filter((s) => s.id !== id));
    };

    const handleSave = () => {
        props.onSectionsChange(sections);
        props.onClose();
    };

    return (
        <div className="loi-form-section-editor-modal">
            <Rodal
                visible={props.isVisible}
                onClose={props.onClose}
                className="checkout-modal create-event-modal"
                width={600}
                animation={'fade'}
                showMask={true}
                centered>
                <ModalHeader>Sections</ModalHeader>
                <ModalBody>
                    <div className="options-list">
                        {sections.length > 0 && (
                        <table className="project-variable-tile">
                            <thead>
                                <tr>
                                    <th>Section name</th>
                                    <th>Linked Term Form Value</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {sectionsOrdered.map((section) => (
                                    <tr key={section.id}>
                                        <td className="section-row-td project-variable-name">
                                            {section.name}
                                        </td>
                                        <td className="section-row-td">
                                            <Input
                                                type="select"
                                                value={
                                                    section.termsFormLinkedField != null
                                                        ? String(section.termsFormLinkedField)
                                                        : ''
                                                }
                                                onChange={(e) => {
                                                    const v = e.target.value;
                                                    handleTermsFormLinkedFieldChange(
                                                        section.id,
                                                        v === '' ? null : (Number(v) as TermsFormLinkedField)
                                                    );
                                                }}
                                                className="form-control form-control-sm terms-form-linked-field-select"
                                                bsSize="sm">
                                                <option value=""></option>
                                                {TermsFormLinkedFieldOptions.map((opt) => (
                                                    <option key={opt.value} value={String(opt.value)}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </Input>
                                        </td>
                                        <td className="section-row-td">
                                            <span className="tile-actions">
                                            <span
                                                className="delete-button"
                                                onClick={() => handleDelete(section.id)}
                                                title="Delete section">
                                                <FontAwesomeIcon icon={faXmark} />
                                            </span>
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        )}
                    </div>
                    {sections.length === 0 && (
                        <div className="text-muted small mt-2">
                            No sections yet. Add one below.
                        </div>
                    )}
                    <div className="add-new-option-form-row">
                        <input
                            type="text"
                            className="form-control"
                            value={newSectionName}
                            onChange={(e) => setNewSectionName(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') handleAdd();
                            }}
                            placeholder="Section name..."
                        />
                        <button
                            className="btn btn-primary"
                            disabled={!newSectionName.trim()}
                            onClick={handleAdd}>
                            + Add
                        </button>
                    </div>
                    <div className="buttons-wrapper">
                        <button
                            className="btn btn-cancel"
                            onClick={props.onClose}>
                            Cancel
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={handleSave}>
                            Save & Close
                        </button>
                    </div>
                </ModalBody>
            </Rodal>
        </div>
    );
};
